/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { USER_QUERY_STALE_TIME } from "@/common/const/query-cache";
import { handleBuscarPorUsuario } from "@/domain/use-cases/cutomers";

export type ITiposEntregaProps = {
  id: number;
  tipo: string;
  endereco_entrega_id: number;
  created_at: string;
  updated_at: string;
};

type IUsuario = {
  id: number;
  nome: string;
  email: string;
  documento: string;
  ativo: number;
  tipo_pessoa: string;
  telefone: string;
  created_at: string;
  createdAt?: string;
  updated_at: string;
  deleted_at: string | null;
  tipo_entrega: ITiposEntregaProps;
};

export interface IUsuarioResponse {
  code: number;
  status: string;
  message: string;
  data: IUsuario;
}

function useBuscarPorUsuario(user_id: number) {
  const { token: accessToken } = useStoreZustandUserAuth();

  // Chave de cache única baseada na página atual e na quantidade de itens por página
  const queryKey = ["um-usuario", user_id];

  const {
    isLoading,
    error: isError,
    data: usuarioResponse,
  } = useQuery<IUsuarioResponse>({
    queryKey,
    enabled: !!user_id && !!accessToken,
    queryFn: async () => {
      const response = await handleBuscarPorUsuario(accessToken!, user_id);

      return response;
    },
    staleTime: USER_QUERY_STALE_TIME,
  });

  const user = usuarioResponse?.data ?? ({} as IUsuario);

  return {
    user: user,
    isLoading,
    isError,
  };
}

/**
 * EXPORTS
 */
export { useBuscarPorUsuario };
